import VueKindergarten from 'vue-kindergarten'

import { registerMessages } from '@argon/app/helpers'

import { authMiddleware } from './auth'
import GroupsPlugin from './groups'
import RolesPlugin from './roles'
import AttributionsPlugin from './attributions'
import * as components from './components'
import { child, navGuard } from './guards'

const messages = {
  en: require('./locale/en'),
  fr: require('./locale/fr')
}

const VuePlugin = {
  install: (Vue, { router, store, i18n }) => {
    Vue.use(VueKindergarten, {
      child: (store) => {
        return child(store)
      }
    })

    navGuard(router, store)
    authMiddleware(store, router)
    registerMessages(i18n, messages)

    Vue.use(GroupsPlugin, { router, store, i18n })
    Vue.use(RolesPlugin, { router, store, i18n })
    Vue.use(AttributionsPlugin, { router, store, i18n })
  }
}

export default VuePlugin
export { components }
